import React, { Suspense, useEffect, useRef, useState } from "react";
import DataLoader from "../../components/FinalMolGrid/ui/dataLoader/DataLoader";
import FormCreator from "../../components/forms/FormCreator";
import Buttons from "../../components/ui/button/Buttons";
import FinalMolGrid from "../../components/FinalMolGrid/FinalMolGrid";
import CenterModel from "../../components/ui/centerModel/CenterModel";
import {
  useGetPaymentReconcilationListMutation,
  useLazyGetAllDropDownsForTaskListQuery,
} from "../../app/services/PaymentReconciliation/PaymentReconciliationApi";
import { setAllDropDownFieldsBatch } from "../../utils/FormFields/FieldsSetting/SetFieldSetting";
import { paginationObj } from "../../utils/Constants";
import { ViewResourcesData } from "./data/ViewResources.Data";
import { ViewResourcesListData } from "./data/ViewResourcesList.Data";
import { useGetAllResourcesListMutation } from "../../app/services/ResourceManagement/ResourseApi";
import { useLazyGetAllDropDownForEventManagementQuery } from "../../app/services/EventManagement/EventManagementApi";
import { useNavigate } from "react-router-dom";

const ViewResourcesForm = () => {
  const resourceListRef = useRef();
  const editViewResourceRef = useRef();
  const navigate = useNavigate();
  /* State */
  const [viewResourcesData, seViewResourcesData] = useState(ViewResourcesData);
  const [dataSource, setDataSource] = useState();
  const [pagination, setPagination] = useState({
    ...paginationObj,
    OrderByColumn: '',
    OrderFlag: null,
    SearchText: "",
    filterByType: null,
    filterByStatus: null,
  });
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);

  const [resourseDetails, setResourceDetails] = useState({
    filterByType: null,
    filterByStatus: null,
  });

  const viewListDropDowns = [
    { dropdownName: "ResourceType", fieldId: "type" },
    { dropdownName: "Status", fieldId: "status" },
  ];

  // API Calls

  const [geEventListDropDown, { isLoading: viewEventListDropDownIsLoading, data: viewEventListDropDownData, isSuccess: viewEvenetListDropDownIsSuccess }] = useLazyGetAllDropDownForEventManagementQuery();
  const [resourceList, { isLoading: resourceListIsLoading, isSuccess: resourceListIsSuccess, data: resourceListData, },] = useGetAllResourcesListMutation();

  // Effect for set dropdown
  useEffect(() => {
    if (!viewEventListDropDownIsLoading && viewEvenetListDropDownIsSuccess && viewEventListDropDownData) {
      // Updates dropdown fields in the form based on the fetched data
      setAllDropDownFieldsBatch(ViewResourcesData, viewListDropDowns, viewEventListDropDownData);
    }
  }, [viewEventListDropDownIsLoading, viewEvenetListDropDownIsSuccess, viewEventListDropDownData]);

  useEffect(() => {
    geEventListDropDown();
    getRecordList(pagination);
  }, []);

  useEffect(() => {
    if (!resourceListIsLoading && resourceListData && resourceListIsSuccess) {
      setDataSource(resourceListData.itemList);
      setPagination((prev) => {
        return { ...prev, totalCount: resourceListData.totalCount };
      });
    }
  }, [resourceListIsLoading, resourceListData, resourceListIsSuccess]);

  // Functions
  const getRecordList = (data) => {
    resourceList(data);
  };

  const handlePageChange = (page) => {
    const { pageNumber, pageSize } = page;
    getRecordList({ ...pagination, pageSize: pageSize, pageNo: pageNumber });
  };

  const searchClick = () => {
    let formData = resourceListRef?.current?.getFormData();
    let request = {
      ...paginationObj,
      SearchText: formData?.resourceName || null,
      filterByType: formData.type?.value || formData?.type,
      filterByStatus: formData?.status?.value || formData?.status,
    };
    setPagination((prev) => {
      return { ...prev, ...request };
    });
    getRecordList(request);
  };

  const handleEditClick = (data) => {
    if (!data) return;
    const { filterByType, filterByStatus } =
      data;
    setResourceDetails({
      ...resourseDetails,
      filterByType: filterByType,
      filterByStatus: filterByStatus,
    });
    openModalEditTaskList();
  };

  const actionHandler = {
    EDIT: handleEditClick,
    // POSTAPPROVAL: handlePOstApprovalClick,
  };

  const openModalEditTaskList = () => {
    setIsEditModalOpen(!isEditModalOpen);
  };
 const handleRedirect = () =>{
  navigate('/createResources')
 }
  return (
    <div>
      <div className="membership-application">
        <div className="form-card mt-4">
        {viewEventListDropDownData &&
          <Suspense fallback={<DataLoader />}>
            <div className="">
              <FormCreator
                config={viewResourcesData}
                ref={resourceListRef}
                key={false}
              />
              <div className="col-lg-12 btn-sec mt-2">
                <div className="col-lg-3 btn-sec mt-2">
                  <Buttons
                    onClick={searchClick}
                    buttonText={"Search"}
                    buttonTypeClassName="theme-btn btn mt-auto"
                    isLoading={false}
                  />
                </div>
                <div className="col-lg-3 btn-sec mt-2">
                  <Buttons
                    onClick={handleRedirect}
                    buttonText={"Create New"}
                    buttonTypeClassName="theme-btn btn mt-auto"
                    isLoading={false}
                  />
                </div>
              </div>
            </div>
          </Suspense>
          }
          <div className="table-100 mt-4">
            <FinalMolGrid
              ref={editViewResourceRef}
              configuration={ViewResourcesListData}
              dataSource={dataSource}
              isLoading={resourceListIsLoading}
              allowPagination={true}
              pagination={pagination}
              onActionChange={actionHandler}
              onPageChange={handlePageChange}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewResourcesForm;
